import { type RouterOutputs } from './trpc';

type BackendPostUpload = NonNullable<
  RouterOutputs['posts']['singlePost']['posts'][0]['uploads']
>[0];

type PostUpload = BackendPostUpload & {
  url?: string; // used by private posts on frontend
};

export type Post = Omit<
  RouterOutputs['posts']['singlePost']['posts'][0],
  'uploads'
> & {
  isPrivate?: boolean; // Flag for private posts
  uploads: PostUpload[] | null;
};

export type PostResponse = RouterOutputs['posts']['feed'] & {
  //added by frontend
  nextTimestamp?: number;
};
export type PostReferencesResponse = RouterOutputs['posts']['references'];
export type WithdrawnPostResponse = RouterOutputs['posts']['withdrawn'];
export type PostEditHistoryItem =
  RouterOutputs['posts']['editHistory']['edits'][0];
export type BotSettings = {
  modelId: number;
  temperature: number;
  maxOutputTokens: number;
};

export type EngagementTimer = {
  startTime: number;
  duration: number;
};

//TODO update this to new schema. User tags are now just an enum UserTag in the db.
export enum UserTag {
  HUMAN = 'HUMAN',
  BOT = 'BOT',
  GOVERNMENT = 'GOVERNMENT',
  ACADEMIA = 'ACADEMIA',
  BUSINESS = 'BUSINESS',
  NEW = 'NEW',
  WAITLIST = 'WAITLIST'
}

export enum VoteType {
  UPVOTE = 'UPVOTE',
  DOWNVOTE = 'DOWNVOTE'
}

export enum postDataSort {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}
